import React, { useState, useMemo } from 'react'
import { useOpenModal } from 'utils/openModal'
import { Tag } from '@bedrock/components'
import CompetitionAnnouncementContent from '#features/CompetitionAnnouncementContent';

type Props = {
    onClose?: () => void,
    updateAnnouncementList: (params: any) => Promise<any>
    refresh: () => void,
    id?: number,
    isList?: boolean
    getList?: () => void
}

export function useOpenBiddingModal(props: Props) {
    const { isList } = props
    const [data, setData] = useState<any>()

    const localOnClose = () => {
        props?.onClose?.()
        props?.refresh?.()
        destroy()
    }

    const showTitle = useMemo(() => {
        if(isList) {
            return '比选公告'
        }
        const name = data?.[0]?.name || '比选公告'

        const status = data?.[0]?.is_willing_invite
        switch (status) {
            case true:
                return <>{name} <Tag color="light-green" text="已接受" /></>
            case false:
                return <>{name} <Tag color="light-red" text="不接受" /></>
            default:
                return <>{name} <Tag color="light-orange" text="待确认" /></>
        }
    }, [data, isList])

    const { open, destroy } = useOpenModal({
        title: showTitle,
        width: 800,
        height: 600,
        footer: null,
        onOk: () => { },
        onCancel: () => {
            localOnClose()
        },
        children: <CompetitionAnnouncementContent {...props} isList={isList} isShow={true} detail={data} onClose={localOnClose} />
    })

    const openBiddingModal = (data) => {
        setData(data)
        open()
    }

    return { openBiddingModal, destroy }
}